import React, { useEffect, useState } from 'react'
// import 'react-awesome-slider/dist/styles.css';
// import "../style.scss"
import Slider from "react-slick";
import { Link, useLocation,useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { _Api } from '../../../common/api';

export default function CollectionSlider({title}) {
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
    const { pathname } = useLocation()
    const { t } = useTranslation();
    const [sliderlist, setSliderlist] = useState([])
   const navigate = useNavigate();
    const [drag ,setDrag] = useState(false);
    const [slidesCount, setSlidesCount] = useState(5);
    // let sliderRef = useRef(null);

    // const next = () => {
    //     sliderRef.slickNext();
    // };

    // const previous = () => {
    //     sliderRef.slickPrev();
    // };
    const sliderdata = async () => {
        try {
            let postdata = {
                type: "collection"
            }
            let res = await _Api(postdata, `product/collections`)
            if (res?.statusCode === 200) {
                setSlidesCount(res?.data?.length >1 ? res?.data?.length : 1)
                setSliderlist(res?.data)
                
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    function SampleNextArrow(props) {
        const { onClick } = props;
        return (
            <div
                className={`sliderarrow top-50 ms-2 translate-middle position-absolute cursor-pointer`}
                style={{ right: '-24px' }}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" color='#fff' width={50} height={50} fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="size-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>

            </div>
        );
    }

    function SamplePrevArrow(props) {
        const { onClick } = props;
        return (
            <div
                className={`sliderarrow lg:ms-5 ms-4 top-50 start-0 translate-middle position-absolute cursor-pointer`}
                style={{ zIndex: 10 }}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" color='#fff' width={50} height={50} fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="size-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                </svg>

            </div>
        );
    }
    const commonSettings = {
        dots: false,
        speed: 500,
        cssEase: "ease-in-out",
        infinite: false,
        beforeChange: () => setDrag(true),
        afterChange: () => setDrag(false),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.4,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 525,
                settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const smallSettings = {
        ...commonSettings,
        slidesToShow: sliderlist.length,
        slidesToScroll: 1,
    };

    const largeSettings = {
        ...commonSettings,
        slidesToShow: 6,
        slidesToScroll: 2,
    };

    const settings = sliderlist.length <= 4 ? smallSettings : largeSettings;
    useEffect(() => {
        sliderdata()
    }, [])

  return (
    <div className='common_collectionslider position-relative'>
        
            {title ?
            <div>
                <div className='common_collectionslider-title'>
                    {title}
                </div>
                </div>
            : null }
        
        
       
        <Slider {...settings}>
        {sliderlist?.length ? sliderlist.map((result, key) => (
            <div className='common_collectionslider-container' key={key} onClick={()=>{if(!drag){ navigate(`/Category/${result.slug}`)}}}>
                {/* <Link to={`/Category/${result.slug}`}> */}
                <img
                    src={result?.logo ? result?.logo : ""}
                    className='common_collectionslider-container-image'
                    alt=""
                />
                {/* </Link> */}
                <div
                    className='common_collectionslider-container-content'
                >
                    <div className='common_collectionslider-container-content-head'>{result?.name}</div>
                    {/* <p className='common_collectionslider-container-content-subtitle'>{result?.description}<br /></p>
                    <button className='common_collectionslider-container-content-btn bg-transparent border-0 d-flex m-auto align-items-center gap-2'>
                        <Link className='text-decoration-none text-white' to={`/Category/${result?.slug}`}
                            onClick={() => { window.scrollTo(0, 0) }}>{t("Show Now")}</Link>
                        <img className='ms-auto' src={base_assets + "images/admin/icons/right-chevron.png"} alt="" />
                    </button> */}
                </div>
            </div>
        )) : ""}
        </Slider>
        
</div >
  )
}






